export default __webpack_public_path__ + "static/media/Blob1.14302a62.svg";